import React from "react";
import { Phone } from "lucide-react";

const ContactInfoItem = ({ Icon, text }) => (
  <p className=" flex items-center px-4 py-2 bg-[#2c3639] text-white font-medium rounded hover:bg-[#a27b5c] transition-colors duration-300 float-right">
    <Icon className="h-5 w-5 mr-2" />
    {text}
  </p>
);

export default function ProductDetails({ title, content, image }) {
  return (
    <div className="py-20 pb-5">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={image}
              alt="ANS SAFETY NETS ,safety nets in bengaluru,"
              tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
Children Safety Nets,
Industrial Safety Nets,
Pets Safety Nets,
Ducteria Nets,
Monkey Safety Nets,
Cricket Practice Nets,
Bird Spikes"
              className="rounded-lg shadow-lg h-[400px] w-[100%] object-cover"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold mb-6">{title}</h2>
            <p className="text-gray-600 mb-4">{content}</p>
            <ContactInfoItem
              Icon={Phone}
              text={
                <a href="tel:+917416116587" className="hover:underline">
                  +91 7416116587
                </a>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
